<template>
  <div>
    <top>
      <Icon slot="left" type="ios-arrow-back" @click="back" />
      <p slot="center">报警分析</p>
      <Icon slot="right" type="md-funnel" />
    </top>
    <month ref="month"></month>
    <Drawer
      placement="top"
      :closable="true"
      :mask="true"
      :draggable="false"
      height="90%"
      v-model="openCar"
    >
      <!-- <carTool @car="reCar"></carTool> -->
    </Drawer>
  </div>
</template>
<script>
import month from "./month.vue";
import carTool from "../../common/carTool.vue";
export default {
  components: {
    month,
    carTool,
  },
  data() {
    return {
      openCar: false,
    };
  },
  methods: {
    reCar(v) {},
    back() {
      this.$router.push({ path: "/home" });
    },
  },
  mounted() {
    //this.$refs.month.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/fenxi/baojing/index.vue